<template>
  <div class="guarantee-info-title">
    <van-cell class="info-title" size="large">
      <!-- 使用 title 插槽来自定义标题 -->
      <template slot="title">
        <div class="blue-title">
          <span
            class="custom-title"
            :class="{ 'has-vertical-line': verticalLine }"
          >
            <span v-if="verticalLine" class="vertical-line" />
            <span class="title-content">
              {{ titleContent }}
            </span>
            <span v-if="requiredDescription" class="required-description"
              >({{ requiredDescription }})
            </span>
          </span>
          <van-button
            v-if="titleButton"
            class="operation-btn"
            plain
            type="info"
            round
            @click="onBtnClick()"
          >
            {{ titleButton }}
          </van-button>

          <span v-if="titleAttention" class="fd-title-attention">{{
            titleAttention
          }}</span>

          <slot name="icon"></slot>
        </div>
      </template>
    </van-cell>
  </div>
</template>

<script>
export default {
  name: "InfoTitle",
  props: [
    "titleContent",
    "requiredDescription",
    "titleAttention",
    "verticalLine",
    "titleButton",
  ],
  methods: {
    onBtnClick() {
      this.$emit("buttonClick", true);
    },
  },
};
</script>

<style lang="less" scoped>
.guarantee-info-title {
  width: 100%;
}

.required-description {
  margin-left: 5px;
  color: #ff3b59;
}

.custom-title {
  display: flex;
  align-items: center;
  &.has-vertical-line {
    .title-content {
      padding-left: 8px;
    }
  }
}

.title-content {
  font-size: 16px;
  color: #2c3542;
  font-weight: 600;
}

.vertical-line {
  width: 3px;
  height: 16px;
  border-radius: 5px;
  background-color: #0096ff;
}

.van-icon-plus {
  font-size: 20px;
}

.van-icon-arrow {
  font-size: 18px;
}

.blue-title {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
}

.info-title {
  background-color: #edf1f8;
  line-height: 40px;
  height: 40px;
  padding: 0 16px;
  min-height: 40px;
  .van-cell__title {
    width: 100%;
    padding-right: 0 !important;
  }
}

.operation-btn {
  height: 25px;
  line-height: 24px;
  margin-top: 6px;
  margin-right: 6px;
}

.fd-title-attention {
  color: #fe4d67;
  font-size: 12px;
}
</style>
